<template>
    <div class="row">
        <div class="col-12">
          <div class="card-header-actions">
            <div class="col-12 justify-content-md-end mt-md-0 mt-2 card-header-btns-box">
              <button class="all-btn add-btn pull-right" @click="showCoefficientOfTerritorialZonesModal(null)">{{$t("action.add")}}</button>
            </div>
          </div>
        </div>
        <div class="col-12">
            <div class="table-wrapper">
              <table class="table table-hover">
                  <thead>
                  <tr>
                      <th>#</th>
                      <th>Вилоят</th>
                      <th>Туман</th>
                      <th>Зона ва коэффициент</th>
                  </tr>
                  </thead>
                  <tbody v-if="!loading && results && results.data">
                  <tr v-for="result in results.data" :key="result.id">
                      <td>{{result.id}}</td>
                      <td>{{result.data.province.label}}</td>
                      <td>{{result.data.region.label}}</td>
                      <td>
                          <template v-if="result.data.childFields && result.data.childFields.length > 0">
                              <div v-for="(field, index) in result.data.childFields" :key="index">
                                  <span>{{field.zone}} - </span>
                                  <span> {{field.value}} </span>
                              </div>
                          </template>
                      </td>
                  </tr>
                  </tbody>
              </table>
            </div>
            <div class="text-center">
                <div class="loader mt-5 mb-5" v-if="loading"></div>
                <span class="no-data mt-5 mb-5" v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty")}}</span>
            </div>
            <div class="row" v-if="!loading && results && results.total && results.total > 1 ">
                <div class="col-12 pt-3 pb-3">
                    <b-pagination :total-rows="results.total" v-model="filter.page.page" :per-page="filter.page.size" @change="onPageChange">
                    </b-pagination>
                </div>
            </div>
        </div>
        <CoefficientOfTerritorialZonesEditModal @change="initList"></CoefficientOfTerritorialZonesEditModal>
    </div>
</template>

<script>
    import CoefficientOfTerritorialZonesEditModal from '@/views/config/rental_rates/CoefficientOfTerritorialZonesEditModal'
    import initFilterModel from '@/shared/filter';
    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';

    export default {
        components: {
            CoefficientOfTerritorialZonesEditModal,
            'b-pagination': bPagination
        },
        data() {
            return {
                loading: false,
                filter: initFilterModel(),
                results: null
            }
        },
        methods: {
            showCoefficientOfTerritorialZonesModal(data) {
                this.$eventBus.$emit('showCoefficientOfTerritorialZonesModal',data)
            },
            initList() {
                this.loading = true;
                const vm = this;
                this.$http.post('dictionary/list/COEFFICIENT_OF_TERRITORIAL_ZONES', this.filter)
                    .then(res => {
                        this.results = res.data;
                        vm.loading = false;
                    }, err => {
                        console.log(err);
                        vm.loading = false;
                    });
            },
            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            }
        },
        created() {
            this.initList();
        }
    }
</script>

<style scoped>

</style>